import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import "./styles/legacy-modals.css";
import { UsersProvider } from "./context/usersContext";
import App from "./app";
import { UserProvider } from "./context/user";
import { Toaster } from "react-hot-toast";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { loadConfig } from "./config";
import env from "./config/env";
import { applyTheme, initSystemListener } from "./lib/theme";
import { applyEnvTitlePrefix, resolveEnvPrefix } from "./lib/envTitle";
import { ThemeProvider as MuiThemeProvider, createTheme } from "@mui/material/styles";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "./lib/queryClient";

// MUI is mid-migration to shadcn (coexistence, retired per-screen). This theme
// only overrides typography so MUI components inherit the app font (var(--font-sans))
// instead of MUI's default Roboto; all other MUI defaults are preserved. Delete
// this bridge once the last MUI screen is migrated.
const muiTheme = createTheme({
  typography: { fontFamily: "var(--font-sans)" },
});

async function bootstrap() {
  applyTheme();
  initSystemListener();
  applyEnvTitlePrefix(); // {{DEV}}/{{LOCAL}} tab-title prefix on non-prod envs
  const config = await loadConfig();
  Object.assign(env, config);

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(

    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <UserProvider>
          <UsersProvider>
            <GoogleOAuthProvider clientId={'4414070894-n3hd59hhhk8cr1tlee8ekaattc7udtgk.apps.googleusercontent.com'}>
              <MuiThemeProvider theme={muiTheme}>
                <App />
                <Toaster position="top-center" reverseOrder={false} />
              </MuiThemeProvider>
            </GoogleOAuthProvider>
          </UsersProvider>
        </UserProvider>
      </BrowserRouter>
      {resolveEnvPrefix() && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}

bootstrap();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
